<script setup>
import AntibiogramTable from '@/views/quality/infection-control/antibiotic/AntibiogramTable.vue'
import RequestTable from '@/views/quality/infection-control/antibiotic/RequestTable.vue'

definePage({
  meta: {
    subject: 'quality.infection_control.menu',
    action: 'antibiotic_stewardship',
  },
})

const activeTab = ref('antibiogram')
</script>

<template>
  <section>
    <VTabs
      v-model="activeTab"
      class="mb-4"
    >
      <VTab value="antibiogram">
        <VIcon
          icon="tabler-chart-grid-dots"
          class="me-2"
          size="18"
        />
        Antibiogram
      </VTab>
      <VTab value="requests">
        <VIcon
          icon="tabler-pill"
          class="me-2"
          size="18"
        />
        Requests
      </VTab>
    </VTabs>

    <VWindow v-model="activeTab">
      <VWindowItem value="antibiogram">
        <AntibiogramTable />
      </VWindowItem>

      <VWindowItem value="requests">
        <RequestTable />
      </VWindowItem>
    </VWindow>
  </section>
</template>
